import { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';

import { AIAssistantPage } from './pages/AIAssistantPage';
import { SHOP_CURRENT_ROUTE } from '../../utils/constants';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/ai-assistant`,
        element: <Outlet />,
        children: [{ index: true, element: <AIAssistantPage /> }],
    },
];
export default routes;
